/* raw layout hash: _user-profile-vehicle-settings-layout:299c1d7b2d7100d615f3cc345c6a34cfa4b67261112a6c67fc13dd63f433489c */
import React from 'react';
import AppShell from './AppShell.jsx';

// Raw layout: _user-profile-vehicle-settings-layout.html — top navbar + mobile bottom bar. Menu entries are role-based (see AppShell / menuData.js).

export default function UserProfileVehicleSettingsLayout() {
  return <AppShell />;
}
